import { ArrowLeftOutlined, CloseOutlined, DownOutlined } from "@ant-design/icons";
import { ColDef, GridApi, SelectionChangedEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { Breadcrumb, ConfigProvider, Input, Pagination, Select, Tabs, TabsProps, TreeSelect } from "antd";
import { PaginationProps } from "antd/lib";
import viVN from 'antd/locale/vi_VN';
import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../../../Layout";
import { getListFieldsRecord, ListField } from "../../../../api/Customer_V2/customerApi_V2";
import * as decentralizationApi from '../../../../api/configuration/decentralizationApi';
import * as groupPermissionApi from "../../../../api/groupPermission/groupPermissionApi";
import * as SelectOptionApi from '../../../../api/selectOptions/selectOptionsApi';
import { NodataTable } from "../../../../components/NoDataTable";
import useDebounce from "../../../../hook/useDebounce";
import useThrottle from "../../../../hook/useThrottle";
import useToast from "../../../../hook/useToast";
import * as fomartUnit from "../../../../services/fomartUnit";
import { dataPagination, fommatSelectOption, setMenuAndPermission } from "../../../../until";
import DataDecentralization from "./Components/DataDecentralization";
import FeatureAuthorization from "./Components/FeatureAuthorization";
import { NO_DATA } from "../../../../services/data";
import { useDispatch, useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import { setMenu } from "../../../../store/slices/menuSlice";
import { convertNationwideValueToTree_V2, flattenUnits } from "../../../../api/unit/unitApi";
import { getCLCategoryCar } from "../../../../api/selectOption/selectOptionsApi";
import { formatNumber } from "../../../../services/mixin";

export interface DataTypeDecentralization {
  parentId?: number
  key: number
  stt: number
  name: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
  // share: boolean
  children?: DataTypeDecentralizationChildren[];
}
export interface DataTypeDecentralizationChildren {
  parentId: number
  key: number
  stt: number
  name: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
  // share: boolean
}





export interface FilterListAccount {
  unitId?: number[],
  businessUnitId?: number
  search?: string
  categoryCarId?: number[]
}

export const initFilterListAccount: FilterListAccount = {
  unitId: undefined,
  businessUnitId: undefined,
  search: undefined
};


export interface IFieldsDecentralization {
  key: string
  name: string
  view: boolean
  edit: boolean
  children?: IFieldsDecentralizationChildren[];
}
export interface IFieldsDecentralizationChildren {
  parentId: number
  key: string
  name: string
  view: boolean
  edit: boolean
  children?: undefined
}
interface IDataDefaulFilterList {
  search: string;
  carLineId?: number
  typeVehicleId?: number
  categoryCarId?: number[]
}

const dataDefaulFilterList = {
  search: "" as string, // Thêm trường search
};

const convertDataMenu = (data: decentralizationApi.IDecentralization[]) => {

  const convertNode = (
    node: decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization,
    path: number[],
    parentId?: number       // chỉ có con mới có giá trị này
  ) => {

    const sttString = path.join(".");

    const newNode: any = {
      parentId: parentId ?? null,   // cha => null, con => id thật của cha
      key: sttString,               // key unique
      id: node.id,                  // giữ id backend
      stt: sttString,
      name: node.name,
      access: node.access,
      add: node.add,
      edit: node.edit,
      delete: node.delete,
      upload: node.upload,
      approve:node.approve,
      download: node.download,
    };

    // xử lý con
    if (node.children && node.children.length > 0) {
      newNode.children = node.children.map((child, index) =>
        convertNode(child, [...path, index + 1], node.id) // 🔥 chỉ cấp dưới mới có parentId
      );
    }

    return newNode;
  };

  // cấp 0 KHÔNG có parentId
  return data.map((item, index) => convertNode(item, [index + 1]));
};



const CreateAccountRole: React.FC = () => {

  const pushToast = useToast();
  const navigator = useNavigate()
  const dispatch = useDispatch()
  const { id, unitTemp, unit } = useSelector(selectorInfoUser)

  useEffect(() => {
    gSLUnit()
    gSLUnitOption()
    gCLCategoryCar()
    gListMenu()
    gSLUnitByPermission()
    gListFieldsRecord()

    return (() => {
      setDataFilterList(dataDefaulFilterList)
      setSelectedStaff([])
      setTitle("")
      setDescription("")

      setSearch(undefined)
      setSearchBackup(undefined)

      setPagination({ current: 1, pageSize: 10, total: 0 })
    })
  }, [])

  const convertDataField = (data: ListField[]) => {
    const convertData = data.map((item) => ({
      key: `${item.id}`,
      name: item.title,
      view: false,
      edit: false,
      children: item.fields?.map((child) => ({
        parentId: item.id,
        key: `${item.id}-${child.id}`,
        name: child.fieldLabel,
        view: false,
        edit: false,
      }))
    }))
    return convertData
  }

  const gridApiRef = useRef<GridApi | null>(null);
  const isRestoringSelection = useRef(false);

  const [openUnit, setOpenUnit] = useState(false);

  const [sLUnitOption, setSLUnitOption] = useState<SelectOptionApi.IUnitOption[]>([])
  const [sLUnit, setSLUnit] = useState<SelectOptionApi.IBusinessUnit[]>([])
  const [valuesUnit, setValuesUnit] = useState<number[]>([])
  const [sLUnitByPermission, setSLUnitByPermission] = useState<any>()
  const [sLUnitByPermissionFlat, setSLUnitByPermissionFlat] = useState<any>()
  const [cLCategoryCar, setCLCategoryCar] = useState<SelectOptionApi.ISelectOption[]>([])

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [valuesUnitList, setValuesUnitList] = useState<{ [userId: number]: number[] }>({});
  const [dataListNationwide, setDataListNationwide] = useState<fomartUnit.OptionSelect_V2[]>([])

  const [search, setSearch] = useState<string>()
  const [searchBackup, setSearchBackup] = useState<string>()
  const [filterAccount, setFilterAccount] = useState<FilterListAccount>(initFilterListAccount)
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')

  const [selectedIdAccount, setSelectedIdAccount] = useState<Set<number>>(new Set());

  const [dataAdmin, setDataAdmin] = useState<decentralizationApi.DataTypeAdminV2[]>([])
  const [listMenu, setListMenu] = useState<decentralizationApi.IDecentralization[]>([])
  const [listFieldsDecentralization, setListFieldsDecentralization] = useState<IFieldsDecentralization[]>([])

  //#region  Cột  data
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: <span className="custom-page-css font-regular text-sm">Phân quyền tính năng</span>,
      children:
        <FeatureAuthorization
          listMenu={listMenu}

          setListMenu={setListMenu}
        />,
    },
    {
      key: '2',
      label: <span className="custom-page-css font-regular text-sm">Phân quyền dữ liệu</span>,
      children:
        <DataDecentralization
          listFieldsDecentralization={listFieldsDecentralization}

          setListFieldsDecentralization={setListFieldsDecentralization}
        />,
    },
  ];

  const staffColumn: ColDef[] = [

    {
      headerName: 'Họ và tên',
      field: 'ho_ten',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 150,
      flex: 1,
    },
    {
      headerName: 'Email',
      field: 'cus_email',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 150,
      flex: 1,
    },
    {
      headerName: 'Phòng ban',
      field: 'phong_ban',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 150,
      flex: 1,
    },
    {
      headerName: 'Khối nghiệp vụ',
      field: 'khoi_nghiep_vu',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 150,
      flex: 1,
    },
    {
      headerName: 'Đơn vị chính',
      field: 'don_vi',
      sortable: true,
      cellRenderer: (params: any) => {
        return <div title={params.value || NO_DATA} className="tooltip-an">
          {params.value || NO_DATA}
        </div>
      },
      width: 200,
      flex: 1,
    },
    {
      headerName: 'Vùng miền',
      field: 'vung_mien',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 120,
      flex: 1,
    },
    {
      headerName: 'Toàn quốc',
      field: 'toan_quoc',
      sortable: true,
      cellRenderer: (params: any) => {
        return <span className="white-space-nowrap">{params.value || NO_DATA}</span>
      },
      width: 120,
      flex: 1,
    },

  ];

  //#endregion

  //#region SELECT (ag-Grid selection handlers & restore)
  // CHECKBOX ON TABLE ROLES
  const [selectedStaff, setSelectedStaff] = useState<React.Key[]>([])

  // Định danh duy nhất cho mỗi row
  const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

  // --- Grid ready ---
  const onGridReady = useCallback((params: { api: GridApi }) => {
    gridApiRef.current = params.api;
  }, []);

  // --- Selection change ---
  const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
    if (isRestoringSelection.current) return;

    const api = event.api;
    const selectedNodes = api.getSelectedNodes().filter(n => n.data);
    const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

    const currentPageIds = (dataAdmin ?? []).map((row: any) => Number(row.id));

    // --- Tạo bản sao của selectedIds hiện tại ---
    const nextSet = new Set(selectedIdAccount);

    // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
    const added: number[] = [];
    const removed: number[] = [];

    // Kiểm tra từng ID trên trang hiện tại
    for (const id of currentPageIds) {
      const isCurrentlySelected = selectedIdsOnPage.includes(id);
      const wasPreviouslySelected = selectedIdAccount.has(id);

      if (isCurrentlySelected && !wasPreviouslySelected) {
        // ID mới được chọn
        added.push(id);
        nextSet.add(id);
      } else if (!isCurrentlySelected && wasPreviouslySelected) {
        // ID bị bỏ chọn
        removed.push(id);
        nextSet.delete(id);
      }
    }

    setSelectedIdAccount(nextSet);
  }, [dataAdmin, selectedIdAccount]);




  // --- Khôi phục selection khi data mới load ---
  useEffect(() => {
    if (gridApiRef.current && dataAdmin && dataAdmin.length > 0) {
      isRestoringSelection.current = true;

      gridApiRef.current.forEachNode((node: any) => {
        if (node.data) {
          const nodeId = Number(node.data.id);
          // Chọn nếu nodeId có trong selectedIdAccount
          node.setSelected(selectedIdAccount.has(nodeId), false, true);
        }
      });

      setTimeout(() => {
        isRestoringSelection.current = false;
      }, 0);
    }
  }, [dataAdmin, selectedIdAccount]); // Thêm selectedIdAccount vào dependency

  //#endregion------------------------------------ End SELECT

  const gSLUnit = async () => {
    const result = await SelectOptionApi.getListBusinessUnit();
    if (result?.status) {
      setSLUnit(result.data);
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }

  const gSLUnitOption = async () => {
    const result = await SelectOptionApi.getSLUnitOption();
    if (result?.status) {
      setSLUnitOption(result.data);
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }

  const gListMenu = async () => {
    const result = await decentralizationApi.getListmenu()
    if (result?.status) {
      setListMenu(convertDataMenu(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
  }

  const gSLUnitByPermission = async () => {
    const result = await SelectOptionApi.getSLUnitByPermission(unitTemp);

    if (result?.status) {
      // setDataListNationwide(unitApi.convertNationwideTree(result.data))
      setSLUnitByPermission(convertNationwideValueToTree_V2(result.data))
      setSLUnitByPermissionFlat(flattenUnits(result.data))
    } else {
    }
  }

  const gCLCategoryCar = async () => {
    const result = await getCLCategoryCar()
    if (result?.status) {
      setCLCategoryCar(fommatSelectOption(result.data))
    }
  }

  const gListFieldsRecord = async () => {
    const result = await getListFieldsRecord()
    if (result?.status) {
      setListFieldsDecentralization(convertDataField(result.data))

    } else {
      pushToast(result?.message, "warning")
    }
  }


  const gListUserAccount = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
    const { unitId, businessUnitId, search } = filterAccount
    const result = await groupPermissionApi.getListUserAccount(
      limit, pageNumber, unitId, businessUnitId, search
    );
    if (result?.status) {
      const newData = convertDataUserAccount(result.data, pageNumber, limit);
      setDataAdmin(newData);
      setPagination({ current: pageNumber, total: result.total, pageSize: limit });

    } else {
      pushToast(result?.message, "error", 2000);
    }
  }, 1000);

  const convertDataUserAccount = (data: groupPermissionApi.IAccount[], pageNumber: number, limit: number) => {
    const convertData = data.map((item) => ({
      key: item.id,
      id: item.id,
      ho_ten: item.fullname,
      cus_email: item.email,
      phong_ban: item.department,
      khoi_nghiep_vu: item.businessUnit,
      don_vi: item.unit,
      vung_mien: item.region,
      toan_quoc: item.nationwide,
    }
    ))
    return convertData
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListUserAccount(pageSize, pageNumber)
  }

  const handleChangeUnit = (selectedValues: number[]) => {

    // console.log(selectedValues)
    setFilterAccount({ ...filterAccount, unitId: selectedValues });
    // setOpenUnit(false)
  };

  const flattenDataMenu = (
    data: decentralizationApi.IDecentralization[]
  ): decentralizationApi.FlattenedData[] => {

    const result: decentralizationApi.FlattenedData[] = [];

    const flatten = (
      items: (decentralizationApi.IDecentralization | decentralizationApi.ChildrenDecentralization)[]
    ) => {
      items.forEach(item => {
        const {
          id, access, add, edit,
          delete: del, upload, download,
          approve, children
        } = item;

        result.push({
          id, access, add, edit,
          delete: del, upload, download, approve
        });

        if (children && children.length > 0) {
          flatten(children);
        }
      });
    };

    flatten(data);
    return result;
  };



  const onFinish = useThrottle(async () => {
    if (!title.trim().length) {
      pushToast("Vui lòng nhập tên nhóm!", "warning");
      return;
    }
    if (!description.trim().length) {
      pushToast("Vui lòng nhập mô tả!", "warning");
      return;
    }

    //title  description
    const { unitId } = filterAccount
    const selectedIdAccountTmp = Array.from(selectedIdAccount)
    const permissionTmp = flattenDataMenu(listMenu);

    const permissionData: groupPermissionApi.IFermissionData[] = listFieldsDecentralization.flatMap(parent => {
      // lọc ra các child có view hoặc edit
      const validChildren = (parent.children ?? []).filter(child => child.view || child.edit);

      // nếu không có child nào thỏa điều kiện thì bỏ qua parent này
      if (validChildren.length === 0) return [];

      // lấy key của parent -> tách recordId và fieldId (nếu có)
      const parentId = parent.key;

      // tạo object cho parent (chỉ thêm 1 lần duy nhất)
      const parentPermission = {
        recordId: Number(parentId),
        fieldId: undefined,
        view: true,
        edit: true
      };

      // tạo danh sách permission cho các child hợp lệ
      const childrenPermissions = validChildren.map(child => {
        const [recordIdStr, fieldIdStr] = child.key.split('-');
        return {
          recordId: Number(recordIdStr),
          fieldId: Number(fieldIdStr),
          view: child.view,
          edit: child.edit
        };
      });

      // gộp parent + children lại
      return [parentPermission, ...childrenPermissions];
    });


    const { categoryCarId: listCategoryCar } = dataFilterList
    const result = await groupPermissionApi.addGroupPermission(
      title, description,
      unitId, selectedIdAccountTmp, permissionTmp, permissionData, listCategoryCar
    );
    if (result?.status) {
      pushToast(result?.message, "success", 2000)

      if (selectedIdAccountTmp.includes(id)) {
        setMenuAndPermission(unitTemp, dispatch, navigator, location.pathname)
      }

      navigator(-1)
    } else {
      pushToast(result?.message, "error", 1000)
    }

  }, 2000);

  useEffect(() => {
    gListUserAccount()
  }, [filterAccount])



  return (
    <Layout>
      <div className="custom-page-css h-full flex flex-col overflow-scroll">
        <div className="app-breadcrumb-block">
          <Breadcrumb
            items={[
              { title: <Link to="/">THACO AUTO CRM</Link>, },
              { title: <Link to="/system-configuration/account-role">Cấu hình</Link>, },
              { title: <Link to="/system-configuration/account-role">Phân quyền</Link>, },
              { title: 'Tạo mới nhóm', },
            ]}
          />
          <div className="d-flex justify-between">
            <div className="app-breadcrumb-title">
              <Link to='/system-configuration/account-role'><ArrowLeftOutlined /></Link>
              <div className="title">Tạo mới nhóm quyền </div>
            </div>
            <button
              className="h-8 px-4 border-none text-white bg-096DD9 rounded-6-px text-sm font-regular"
              onClick={onFinish}
            >
              Lưu nhóm quyền
            </button>
          </div>

        </div>
        <div className=" w-full pb-18-px">
          <div className="d-flex gap-3 rounded-1   py-2 ">
            <div className='d-flex align-center gap-10-px w-half'>
              <p className='text-base fw-500 font-medium white-space-nowrap'>Tên nhóm</p>
              <Input
                placeholder="Ví dụ: Nhóm cấp cao"
                className="custom-input-css custom-page-css border"
                maxLength={50}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className='d-flex align-center gap-10-px w-half'>
              <p className='text-base fw-500 font-medium white-space-nowrap'>Mô tả ngắn</p>
              <Input
                placeholder="Ví dụ: Nhóm cấp cao"
                className="custom-input-css custom-page-css border"
                maxLength={50}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <p className='text-base fw-500 font-medium white-space-nowrap'>Thương hiệu</p>
          <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                mode="multiple"
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select  line-none line-none-item inline-none size-selector "
                variant="borderless"
                placeholder="Chọn thương hiệu"
                suffixIcon={null}
                options={cLCategoryCar}
                filterOption={(input: string, option: any) =>
                  typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                value={dataFilterList.categoryCarId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, categoryCarId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <Tabs
          defaultActiveKey="1"
          items={items}
        //  onChange={onChange}
        />

        <div className=" gap-2 custom-page-css flex flex-col flex-1 justify-between">
          <div className="d-flex gap-10-px items-start">
            <div className="custom-page-css flex flex-2">
              <TreeSelect
                className={'custome-select-t w-full border-F2F4F7'}
                multiple
                showSearch
                placeholder="Chọn đơn vị"
                allowClear
                value={filterAccount.unitId}
                treeDefaultExpandAll={false}
                treeData={sLUnitByPermission}
                filterTreeNode={(input: string, option: any) =>
                  typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={handleChangeUnit}
              />
            </div>
            <div className='custom-page-css flex flex-1'>
              <Select
                allowClear
                placeholder="Khối/Nghiệp vụ"
                options={fommatSelectOption(sLUnit)}
                className="custome-select-t border-F2F4F7"

                value={filterAccount?.businessUnitId}
                onChange={(e) => setFilterAccount({ ...filterAccount, businessUnitId: e })}
              />
            </div>
            <div className="custom-page-css flex flex-2">
              <Input
                allowClear
                placeholder="Tìm tài khoản để phân quyền"
                className="custom-input-css custom-page-css border"
                value={filterAccount.search}
                onChange={(e) => setFilterAccount({ ...filterAccount, search: e.target.value })}
              />
            </div>

          </div>
          <div className="w-full flex gap-3">
            <span className="text-sm font-regular custom-page-css flex shrink-0">Bộ lọc đã chọn:  </span>
            <div className={` ${filterAccount?.unitId?.length !== 0 ? 'd-flex align-center gap-2 flex-wrap' : 'none'}`}>
              {
                filterAccount?.unitId?.map((value, index) => {
                  const selectedOption =
                    sLUnitByPermissionFlat.find((option: any) => option.value === value);
                  if (!selectedOption) return null;
                  return (
                    <p key={index} className="bg-F9FAFB border-F2F4F7 rounded-2  text-xs px-2 d-flex align-center gap-3-px py-1 font-regular">
                      {selectedOption.label}
                      <CloseOutlined
                        className="text-84878C text-xs cursor-pointer"
                        onClick={() => setFilterAccount({ ...filterAccount, unitId: filterAccount.unitId?.filter(v => v !== value) })}
                      />
                    </p>
                  )
                })
              }
            </div>
          </div>
          <div className="w-full flex gap-3">
            <span className="text-sm font-regular">Đã chọn: {selectedIdAccount.size} tài khoản </span>
          </div>
          <div className={`order-history-card__body pt-2 custom-page-css flex flex-col flex-1 justify-between`}>
            <div className=" ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
              <AgGridReact domLayout="autoHeight" className="my-auto-height-grid" getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
                rowData={dataAdmin}
                rowHeight={55}
                columnDefs={staffColumn}
                rowSelection={{ mode: 'multiRow' }}

                overlayNoRowsTemplate={NodataTable}
                suppressDragLeaveHidesColumns={true}

                getRowId={getRowId}
                onGridReady={onGridReady}
                onSelectionChanged={onSelectionChanged}
              />

            </div>
            <ConfigProvider locale={viVN}>
              <div className="pagination-block">
                <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
                  itemRender={(page, type, originalElement) => {
                    // Chỉ custom khi là nút số trang
                    if (type === 'page') {
                      return <span>{formatNumber(page)}</span>;
                    }
                    // prev / next / jump-prev / jump-next giữ nguyên
                    return originalElement;
                  }}
                  showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                    pagination.current).totalPage} trang`}
                  className='rs-pagination'
                  onChange={onPaginationChange}
                />
              </div>
            </ConfigProvider>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default CreateAccountRole
